'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { QRCodeSVG } from 'qrcode.react';

import styles from './styles.module.css';

import { buildStaticUrl } from '@/constants/endpoints';

const DEPOP_APP_ICON = buildStaticUrl('/web/assets/depop-logo-white.png');
const DEFAULT_QR_SIZE = 130;
const EXCAVATION_SIZE_RATIO = 32 / DEFAULT_QR_SIZE;
const EXCAVATION_PLACEHOLDER =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

type Props = {
  value: string;
  size?: number;
  showLogo?: boolean;
  ariaLabel?: string;
  fillParent?: boolean;
};

export function BranchQRCode({
  value,
  size = DEFAULT_QR_SIZE,
  showLogo = true,
  ariaLabel,
  fillParent = false,
}: Props) {
  const t = useTranslations('common');

  const excavationSize = Math.round(size * EXCAVATION_SIZE_RATIO);

  return (
    <div
      className={clsx(styles.container, {
        [styles.containerFillParent]: fillParent,
      })}
    >
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        role="img"
        aria-label={ariaLabel ?? t('GetTheApp.QRCode.Alt')}
        className={clsx(styles.qrCode, {
          [styles.qrCodeFillParent]: fillParent,
        })}
        imageSettings={
          showLogo
            ? {
                src: EXCAVATION_PLACEHOLDER,
                width: excavationSize,
                height: excavationSize,
                excavate: true,
              }
            : undefined
        }
      />
      {showLogo && (
        <span className={styles.badge} aria-hidden>
          <img src={DEPOP_APP_ICON} alt="" className={styles.badgeLogo} />
        </span>
      )}
    </div>
  );
}
